// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"ed8e6f7a","92":"61f05d9f","99":"f76122ba","215":"aed74b9c","337":"f3fa15d4","443":"0c07b80b","479":"8690f397","531":"8a0f71f2","804":"00223b56"}[chunkId] + ".chunk.js";
};